module.exports = __webpack_public_path__ + "static/media/penimage.36f5b657.svg";